// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d9a14a4f","455":"4714ef0b","977":"9ca56ec3"}[chunkId] + ".chunk.js";
};